/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiDomainHosterFromJSON, ApiDomainHosterToJSON, } from './ApiDomainHoster';
export function ApiDomainPayloadFromJSON(json) {
    return ApiDomainPayloadFromJSONTyped(json, false);
}
export function ApiDomainPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'description': !exists(json, 'description') ? undefined : json['description'],
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'hoster': !exists(json, 'hoster') ? undefined : ApiDomainHosterFromJSON(json['hoster']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'subdomain': !exists(json, 'subdomain') ? undefined : json['subdomain'],
    };
}
export function ApiDomainPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'description': value.description,
        'domain': value.domain,
        'hoster': ApiDomainHosterToJSON(value.hoster),
        'name': value.name,
        'subdomain': value.subdomain,
    };
}
